// Animation Observer
const observerOptions = {
	root: null,
	rootMargin: "0px",
	threshold: 0.1,
};

const observer = new IntersectionObserver((entries, observer) => {
	entries.forEach((entry) => {
		if (entry.isIntersecting) {
			entry.target.classList.add("is-visible");
			observer.unobserve(entry.target);
		}
	});
}, observerOptions);

document
	.querySelectorAll(
		".section-intro, .section-stats, .section-vision, .section-team",
	)
	.forEach((section) => {
		observer.observe(section);
	});
